// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatElement.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Format Element
 */
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');
  var transaction = require('mobx').transaction;
  var classnames = require('classnames');

  var Panel = require('share/components/controls/Izenda.Panel');
  var FormatItem = require('./Izenda.ReportFormatItem');
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  var ReportBodyConstants = require('logic/data/Izenda.ReportBodyConstants');
  var GridItem = require('share/components/controls/GridLayout/Izenda.GridItem');
  var AddItemPopup = require('modules/ReportDesigner/Formats/Izenda.AddItemPopup');
  var FormatItemPropertiesSchema = require('modules/ReportDesigner/Formats/Izenda.FormatItemSchema');
  var ReportFormatLayoutUIStore = require('./Izenda.ReportFormatLayoutUIStore');

  var Droppable = require('share/components/hoc/Izenda.Droppable');
  var DnDFormatItemConfig = require('modules/ReportDesigner/Formats/Izenda.DnDFormatsConfig');
  var GridView = require('share/components/controls/GridLayout/Izenda.GridView');
  var FormatGridView = Droppable(
    ReportBodyConstants.DRAG_ITEM.REPORT_PART_FIELD_ITEM,
    DnDFormatItemConfig.targetOptions
  )(GridView);
  var { forEach, isEqual, some, find, placeholder } = require('lodash/fp');

  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var FORMAT_ITEM_EDITOR = [
    {
      name: 'formatItemProps',
      getDefinedSchema: FormatItemPropertiesSchema
    }
  ];

  var ReportFormatElement = React.createClass({
    propTypes: {
      store: React.PropTypes.object,
      formatElement: React.PropTypes.object,
      title: React.PropTypes.string,
      cols: React.PropTypes.number,
      rows: React.PropTypes.number,
      width: React.PropTypes.number,
      afterToggled: React.PropTypes.func
    },

    /**
     * Make ElementResizeDetector listen to the DOM when this component is mounted
     */
    componentWillMount: function() {
      var width = this.props.width;
      var rows = this.props.rows;
      var cols = this.props.cols;
      this.layoutStore = new ReportFormatLayoutUIStore(width, rows, cols);

      // this.dispose = this.reactiveUpdateLayout();
    },
    componentWillReceiveProps: function(nextProps) {
      if (nextProps.width !== this.props.width) {
        this.layoutStore.setViewWidth(nextProps.width);
      }
    },

    componentDidMount: function() {
      const dom = ReactDOM.findDOMNode(this);
      this.layoutStore.setViewWidth(dom.clientWidth);
    },

    shouldComponentUpdate: function(nextProps) {
      return nextProps.width !== this.props.width;
    },

    /**
     * render list format items
     * @returns {Array}
     */
    renderListFormatItems: function() {
      var props = this.props || {};
      var store = props.store || {};
      var formatElement = props.formatElement;
      var formatItems = formatElement.formatItems;
      var context = this.context || {};

      return formatItems.map(function(data) {
        return (
          <GridItem
            key={data.id}
            id={data.id}
            isDraggable={true}
            isResizable={true}
            cancel='input.form-control, a'
            fillWidth={props.fillWidth}
            minHeight={data.minHeight}
            useItemMinHeight
            cols={props.cols}
          >
            <FormatItem
              itemData={data}
              propsEditors={FORMAT_ITEM_EDITOR}
              formatElement={formatElement}
              context={context}
              store={store}
              {...props}
            />
          </GridItem>
        );
      });
    },

    /**
     * Calculate real width side.
     */
    getRealValueOnXAxis: function() {
      var props = this.props || {};
      var formatElement = props.formatElement;
      var formatItems = formatElement.formatItems;
      var maxValue = 0;

      forEach(function(item) {
        var value = item.positionX + item.width;
        if (value > maxValue) {
          maxValue = value;
        }
      }, formatItems);

      return maxValue;
    },

    /**
     * Render header of panel
     * @param  {Object} props
     */
    renderHeader: function(collapsibleProps) {
      var props = this.props;
      var viewMode = props.viewMode;
      var formatElement = props.formatElement;

      var onChange = function(item) {
        var defaultConfig = CONSTANTS.ITEMS_TYPE[item.value];
        formatElement.addItem && formatElement.addItem(item.value, defaultConfig.width, defaultConfig.height);
      };

      return (
        <div className='inline-block full-width'>
          <strong onClick={collapsibleProps.collapseToggle} className='report-format-label'>
            <i className='icon-toggle-thick' /> {props.title}
          </strong>
          {viewMode ? null : <AddItemPopup className='pull-right' onChange={onChange} />}
        </div>
      );
    },

    render: function() {
      var props = this.props;
      var formatElement = props.formatElement;
      var afterToggled = props.afterToggled;

      var header = {
        component: this.renderHeader
      };

      var layoutStore = this.layoutStore;
      var layoutData = formatElement.formatItems.map(toFormatLayoutItem);

      var renderContent = function() {
        // Note that this view need to attach onDrop for
        // drop in function.
        return (
          <FormatGridView
            className={this.props.className}
            layoutStore={layoutStore}
            layoutData={layoutData}
            flatTransformStyle={true}
            editable={!props.viewMode}
            onDrop={this.onDrop}
            allowAddInline={false}
            onUpdateItemPositions={this.onUpdateItemPositions}
            showLoading={false}
            horizontalAlign={props.horizontalAlign}
            maxWidth={this.getRealValueOnXAxis() * layoutStore.cellWidth}
          >
            {this.renderListFormatItems()}
          </FormatGridView>
        );
      }.bind(this);

      var reportFormatElementClass = props.setting
        ? classnames('report-format-element', props.className)
        : classnames('report-format-element');

      return props.viewMode ? (
        <div className={reportFormatElementClass} style={props.style}>
          {' '}
          {renderContent()}{' '}
        </div>
      ) : (
        <Panel header={header} afterToggled={afterToggled} collapsible initState className='report-format-element'>
          {renderContent()}
        </Panel>
      );
    },
    /**
     * Update new report format item positions
     * @param  {Array} newItemPos    Array of new item positions
     */
    onUpdateItemPositions: function(newItemPos) {
      var needItemUpdate = function(item) {
        return some({ id: item.id }, newItemPos);
      };

      var setPosition = function(item) {
        var newPos = find({ id: item.id }, newItemPos);

        if (
          !isEqual(
            newPos, {
              id: item.id,
              left: item.positionX,
              top: item.positionY,
              width: item.width,
              height: item.height
            }
          )
        ) {
          item.setPosition({
            positionX: newPos.left,
            positionY: newPos.top,
            width: newPos.width,
            height: newPos.height
          });
        }
      };

      var formatItems = this.props.formatElement.formatItems;
      transaction(function() {
        placeholder(formatItems)
          .filter(needItemUpdate)
          .forEach(setPosition);
      });
    },
    /**
     * Calls when a format item has been dropped in.
     * @param  {Object} item A format item including type
     */
    onDrop: function(item) {
      var defaultConfig = CONSTANTS.ITEMS_TYPE[item.type];
      var formatElement = this.props.formatElement;
      formatElement.addItem(item.type, defaultConfig.width, defaultConfig.height);
    }
  });

  /**
   * Convert report format item to grid layout item
   */
  function toFormatLayoutItem(item) {
    return {
      id: item.id,
      x: item.positionX,
      y: item.positionY,
      width: item.width,
      height: item.height,
      isFullSize: false
    };
  }

  module.exports = connect(Dimensions)(ReportFormatElement);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.ReportFormatElement.jsx